import styled from '@emotion/styled';
import { Select } from 'src/components-dummy';

export const AutoRedirectSelectStyled = styled(Select)`
  max-width: 326px;
`;
